import { PaymentScheduleRow } from "../../../domain/proposals/settings/proposalSettings";
import { addPaymentRow, deletePaymentRow, PaymentScheduleAction, updatePaymentNote, updatePaymentPercentage, updatePaymentTitle } from "../../Proposals/paymentScheduleModel";

export const progressBasedReducer = (state: PaymentScheduleRow[], action: PaymentScheduleAction) => {
  switch (action.type) {
    case 'addPayment':
      return addPaymentRow(state, action.index)
    case 'deletePayment':
      return deletePaymentRow(state, action.index)
    case 'updatePaymentTitle':
      return updatePaymentTitle(state, action.index, action.value)
    case 'updatePaymentNote':
      return updatePaymentNote(state, action.index, action.value)
    case 'updatePaymentPercentage':
      return updatePaymentPercentage(state, action.index, action.value, 0.01)
  }
}
